module.exports = __webpack_public_path__ + "img/show_tc_text_10.26701535.png";